/* eslint-disable indent */
//#region Imports

import { put } from 'redux-saga/effects';
import { extractErrorFromResponse } from '../../assets/js/function-utils';
import TXT_EMAIL_DATA from '../../consts/txt-email-data';
import api from '../../services/api';
import SessionService from '../../session/session-service';
import { Creators as DadosComplementares } from '../ducks/dados-complementares';
import DADOS_SIM from './../../consts/consts';
import { LISTA_BENS_FIELDS } from './../../consts/dados-complementares-fields';
import ENDPOINTS from './../../consts/endpoints';
import { onlyNums, strCommaNumberToFloat } from './../../normalizers/normalize';

//#endregion

const beneficiarioValues = DADOS_SIM.BENEFICIARIOS;
const enderecoValues = DADOS_SIM.ENDERECO;
const pagamentoValues = DADOS_SIM.PAGAMENTO;
const dadosClienteValues = DADOS_SIM.DADOS_CLIENTE;
const cotacaoValues = DADOS_SIM.DADOS_COTACAO;
const txtEmailDataValues = TXT_EMAIL_DATA;
const coCorretagemValues = DADOS_SIM.COCORRETAGEM;
const listaBemValues = DADOS_SIM.LISTA_BENS;
const detalheEquipamentoValues = DADOS_SIM.DETALHES_EQUIPAMENTOS;
const objEnvioFields = LISTA_BENS_FIELDS;
const informacaoAdicionalFields = LISTA_BENS_FIELDS.INFORMACAO_ADICIONAL;
const dadosBancariosFields = LISTA_BENS_FIELDS.DADOS_BANCARIOS;
const beneficiarioFields = LISTA_BENS_FIELDS.BENEFICIARIOS;
const enderecoFields = LISTA_BENS_FIELDS.ENDERECO;
const coCorretagemFields = LISTA_BENS_FIELDS.COCORRETAGEM;
const geoLocalizacaoFields = LISTA_BENS_FIELDS.GEOLOCALIZACAO;
const detalhesEquipamentosFields = LISTA_BENS_FIELDS.DETALHE_EQUIPAMENTO;

export function* sendDadosComplementares(action) {
    try {
        const objEnvio = adjustDadosComplementares(
            action.payload.objEnvio,
            action.payload.listaBeneficiarios,
            action.payload.listaEnderecos
        );

        const { data } = yield api.patch(ENDPOINTS.SEND_DADOS_COMPLEMENTARES(action.payload.codigoCotacao), objEnvio);

        if (data) {
            const statusCotacao = data.resultado[cotacaoValues.STATUS_COTACAO];
            const mensagemErroEnvioTxt =
                data.resultado[txtEmailDataValues.THIS] &&
                data.resultado[txtEmailDataValues.THIS][txtEmailDataValues.MENSAGEM_ERRO];
            SessionService.saveSession({
                [cotacaoValues.STATUS_COTACAO]: statusCotacao,
                [txtEmailDataValues.MENSAGEM_ERRO]: mensagemErroEnvioTxt
            });
            yield put(DadosComplementares.sendDadosComplementaresSuccess(data));
        }
    } catch (err) {
        yield put(DadosComplementares.sendDadosComplementaresFailure(extractErrorFromResponse(err)));
    }
}

const adjustDadosComplementares = (dados, listaBeneficiarios, listaEnderecos) => {
    const { jornadaPenhorRural } = SessionService.getSession();
    const { listaBensGarantia, listaBensNaoGarantia, dadosContato } = dados;
    const dadosFormaPagamento = dados[pagamentoValues.THIS];
    const dadosCoCorretagem = dados[coCorretagemValues.THIS];

    let toSendListaBens = [...listaBensGarantia, ...listaBensNaoGarantia];

    toSendListaBens = adjustListWithObjectBeneficiario(toSendListaBens, listaBeneficiarios);

    toSendListaBens = adjustListWithObjectEndereco(toSendListaBens, listaEnderecos);
    toSendListaBens = adjustListCoordenadasGeograficas(toSendListaBens);
    toSendListaBens = adjustListDetalhesEquipamentos(toSendListaBens);

    if (jornadaPenhorRural) {
        toSendListaBens = adjustWithDadosFiduciarios(toSendListaBens);
    }

    toSendListaBens = clearListToSend(toSendListaBens);

    let toSendCoCorretagem = createCoCorretagemObject(dadosCoCorretagem);

    let objEnvio = {
        [pagamentoValues.COMBO_PARCELAMENTO]: dados[pagamentoValues.COMBO_PARCELAMENTO],
        [objEnvioFields.BENS]: toSendListaBens,
        [coCorretagemFields.THIS]: toSendCoCorretagem,
        [informacaoAdicionalFields.THIS]: {
            [informacaoAdicionalFields.EMAIL_ADICIONAL]: dadosContato[dadosClienteValues.EMAIL_ADICIONAL],
            [informacaoAdicionalFields.EMAIL_SOLICITANTE]: dadosContato[dadosClienteValues.EMAIL_SOLICITANTE],
            [informacaoAdicionalFields.TELEFONE_ADICIONAL]: dadosContato[dadosClienteValues.TELEFONE_ADICIONAL]
        },
        [dadosBancariosFields.FORMA_PAGAMENTO]: {
            [dadosBancariosFields.DIA_VENCIMENTO]: dadosFormaPagamento[pagamentoValues.DIA_VENCIMENTO],
            [dadosBancariosFields.DIGITO_AGENCIA]: dadosFormaPagamento[pagamentoValues.DIGITO_AGENCIA],
            [dadosBancariosFields.DIGITO_CONTA]: dadosFormaPagamento[pagamentoValues.DIGITO_CONTA],
            [dadosBancariosFields.FORMA_PAGAMENTO]:
                dadosFormaPagamento[pagamentoValues.FORMA_PAGAMENTO] === 'DebitoCC' ? 'DEBITO_CONTA' : 'BOLETO',
            [dadosBancariosFields.NUMERO_AGENCIA]: dadosFormaPagamento[pagamentoValues.NUMERO_AGENCIA],
            [dadosBancariosFields.NUMERO_CONTA]: dadosFormaPagamento[pagamentoValues.CONTA_BB]
        }
    };
    return objEnvio;
};

const adjustListWithObjectBeneficiario = (listaBens, listaBeneficiarios) => {
    const { jornadaPenhorRural } = SessionService.getSession();

    return listaBens.map((bem) => {
        let beneficiariosToSend = bem[beneficiarioValues.THIS].map((beneficiarioBem) => {
            const beneficiario = listaBeneficiarios.find(
                (beneficiarioLista) =>
                    beneficiarioLista[beneficiarioValues.ID_BENEFICIARIO] ===
                    beneficiarioBem[beneficiarioValues.ID_BENEFICIARIO]
            );

            if (jornadaPenhorRural) {
                return {
                    cnpj: onlyNums(beneficiario.cnpj),
                    cpf: null,
                    nomeCompleto: null,
                    percParticipacao: beneficiarioBem.valueLMI,
                    instituicao: {
                        bancoId: beneficiario.bancoId,
                        nomeBanco: beneficiario.nomeBanco,
                        id: Number(beneficiario.bancoId)
                    },
                    dadosBancarios: null
                };
            }

            return {
                [beneficiarioFields.CNPJ]:
                    beneficiario[beneficiarioValues.CPF_CNPJ_BENEFICIARIO].length === 18
                        ? onlyNums(beneficiario[beneficiarioValues.CPF_CNPJ_BENEFICIARIO])
                        : null,
                [beneficiarioFields.CPF]:
                    beneficiario[beneficiarioValues.CPF_CNPJ_BENEFICIARIO].length === 14
                        ? onlyNums(beneficiario[beneficiarioValues.CPF_CNPJ_BENEFICIARIO])
                        : null,
                [beneficiarioFields.NOME_COMPLETO]: beneficiario[beneficiarioValues.NOME_BENEFICIARIO],
                [beneficiarioFields.PERCENTUAL_PARTICIPACAO]: beneficiarioBem[beneficiarioValues.VALOR_LMI],
                [dadosBancariosFields.THIS]:
                    beneficiario[pagamentoValues.ID_BANCO] !== undefined &&
                    beneficiario[pagamentoValues.ID_BANCO] !== ''
                        ? {
                              [dadosBancariosFields.BANCO_ID]: beneficiario[pagamentoValues.ID_BANCO],
                              [dadosBancariosFields.DIGITO_AGENCIA]: beneficiario[pagamentoValues.DIGITO_AGENCIA],
                              [dadosBancariosFields.DIGITO_CONTA]: beneficiario[pagamentoValues.DIGITO_CONTA],
                              [dadosBancariosFields.NUMERO_AGENCIA]: beneficiario[pagamentoValues.NUMERO_AGENCIA],
                              [dadosBancariosFields.NUMERO_CONTA]: beneficiario[pagamentoValues.NUMERO_CONTA],
                              [dadosBancariosFields.TIPO_CONTA]: beneficiario[pagamentoValues.FORMA_PAGAMENTO]
                          }
                        : null
            };
        });

        return {
            ...bem,
            [beneficiarioFields.THIS]: [...beneficiariosToSend]
        };
    });
};

const adjustListWithObjectEndereco = (listaBens, listaEnderecos) => {
    return listaBens.map((bem) => {
        let endereco = listaEnderecos.find((endereco) => endereco.id === bem[enderecoValues.ID_ENDERECO]);

        return {
            ...bem,
            [enderecoFields.THIS]: {
                [enderecoFields.BAIRRO]: endereco[enderecoValues.BAIRRO_DISTRITO],
                [enderecoFields.CEP]: endereco[enderecoValues.CEP],
                [enderecoFields.CIDADE]: endereco[enderecoValues.CIDADE],
                [enderecoFields.COMPLEMENTO]: endereco[enderecoValues.COMPLEMENTO],
                [enderecoFields.LOGRADOURO]: endereco[enderecoValues.RUA_ESTRADA],
                [enderecoFields.NOME_PROPRIEDADE]: endereco[enderecoValues.NOME_PROPRIEDADE],
                [enderecoFields.NUMERO]: endereco[enderecoValues.NUMERO_PROPRIEDADE],
                [enderecoFields.UF]: endereco[enderecoValues.UF]
            }
        };
    });
};

const createCoCorretagemObject = (dadosCoCorretagem) => {
    let objCoCorretagem = [];

    if (dadosCoCorretagem && dadosCoCorretagem[coCorretagemValues.CNPJ_CORRETORA1]) {
        objCoCorretagem.push({
            [coCorretagemFields.CNPJ]: onlyNums(dadosCoCorretagem[coCorretagemValues.CNPJ_CORRETORA1]),
            [coCorretagemFields.NOME_CORRETORA]: dadosCoCorretagem[coCorretagemValues.NOME_CORRETORA1]
        });
    }
    if (dadosCoCorretagem && dadosCoCorretagem[coCorretagemValues.CNPJ_CORRETORA2]) {
        objCoCorretagem.push({
            [coCorretagemFields.CNPJ]: onlyNums(dadosCoCorretagem[coCorretagemValues.CNPJ_CORRETORA2]),
            [coCorretagemFields.NOME_CORRETORA]: dadosCoCorretagem[coCorretagemValues.NOME_CORRETORA2]
        });
    }
    if (dadosCoCorretagem && dadosCoCorretagem[coCorretagemValues.CNPJ_CORRETORA3]) {
        objCoCorretagem.push({
            [coCorretagemFields.CNPJ]: onlyNums(dadosCoCorretagem[coCorretagemValues.CNPJ_CORRETORA3]),
            [coCorretagemFields.NOME_CORRETORA]: dadosCoCorretagem[coCorretagemValues.NOME_CORRETORA3]
        });
    }
    return objCoCorretagem;
};

const adjustListCoordenadasGeograficas = (listaBens) => {
    return listaBens.map((bem) => {
        let objCoordenada = null;
        if (bem[listaBemValues.COORDENADAS]) {
            objCoordenada = {
                [geoLocalizacaoFields.LATITUDE]: {
                    [geoLocalizacaoFields.DIRECAO]:
                        bem[listaBemValues.COORDENADAS][geoLocalizacaoFields.LATITUDE][geoLocalizacaoFields.DIRECAO],
                    [geoLocalizacaoFields.GRAU]: strCommaNumberToFloat(
                        bem[listaBemValues.COORDENADAS][geoLocalizacaoFields.LATITUDE][geoLocalizacaoFields.GRAU]
                    ),
                    [geoLocalizacaoFields.MINUTO]: strCommaNumberToFloat(
                        bem[listaBemValues.COORDENADAS][geoLocalizacaoFields.LATITUDE][geoLocalizacaoFields.MINUTO]
                    ),
                    [geoLocalizacaoFields.SEGUNDO]: strCommaNumberToFloat(
                        bem[listaBemValues.COORDENADAS][geoLocalizacaoFields.LATITUDE][geoLocalizacaoFields.SEGUNDO]
                    )
                },
                [geoLocalizacaoFields.LONGITUDE]: {
                    [geoLocalizacaoFields.DIRECAO]:
                        bem[listaBemValues.COORDENADAS][geoLocalizacaoFields.LONGITUDE][geoLocalizacaoFields.DIRECAO],
                    [geoLocalizacaoFields.GRAU]: strCommaNumberToFloat(
                        bem[listaBemValues.COORDENADAS][geoLocalizacaoFields.LONGITUDE][geoLocalizacaoFields.GRAU]
                    ),
                    [geoLocalizacaoFields.MINUTO]: strCommaNumberToFloat(
                        bem[listaBemValues.COORDENADAS][geoLocalizacaoFields.LONGITUDE][geoLocalizacaoFields.MINUTO]
                    ),
                    [geoLocalizacaoFields.SEGUNDO]: strCommaNumberToFloat(
                        bem[listaBemValues.COORDENADAS][geoLocalizacaoFields.LONGITUDE][geoLocalizacaoFields.SEGUNDO]
                    )
                }
            };
        }

        return {
            ...bem,
            [geoLocalizacaoFields.THIS]: objCoordenada ? objCoordenada : null
        };
    });
};

const adjustListDetalhesEquipamentos = (listaBens) => {
    return listaBens.map((bem) => {
        return {
            ...bem,
            [detalhesEquipamentosFields.THIS]: {
                [detalhesEquipamentosFields.FABRICANTE]: bem[detalheEquipamentoValues.FABRICANTE],
                [detalhesEquipamentosFields.MODELO]: bem[detalheEquipamentoValues.MODELO],
                [detalhesEquipamentosFields.CHASSI]: bem[detalheEquipamentoValues.CHASSI]
            }
        };
    });
};

const adjustWithDadosFiduciarios = (listaBens) =>
    listaBens.map((bem) =>
        bem.inGarantia
            ? {
                  ...bem,
                  dadosFiduciarios: {
                      cnpj: bem.cnpj,
                      instituicao: bem.instituicao,
                      numContratoFiduciario: bem.numContratoFiduciario
                  }
              }
            : bem
    );

const clearListToSend = (listaBens) => {
    return listaBens.map((bem) => {
        return {
            [beneficiarioFields.THIS]: [...bem[listaBemValues.BENEFICIARIOS]],
            [detalhesEquipamentosFields.THIS]: bem[detalhesEquipamentosFields.THIS]
                ? bem[detalhesEquipamentosFields.THIS]
                : null,
            [enderecoFields.THIS]: bem[listaBemValues.ENDERECO],
            [geoLocalizacaoFields.THIS]: bem[geoLocalizacaoFields.THIS],
            [geoLocalizacaoFields.POLIGONOS]: bem[geoLocalizacaoFields.POLIGONOS],
            [objEnvioFields.ID_COTACAO_BEM]: bem[objEnvioFields.ID_COTACAO_BEM],
            [listaBemValues.GARANTIA]: bem[listaBemValues.GARANTIA],
            dadosFiduciarios: bem.dadosFiduciarios
        };
    });
};
